import { render } from "./trainingRequirements.svg?vue&type=template&id=e716469c"
const script = {}
script.render = render

export default script